import { render, staticRenderFns } from "./SchoolRank.vue?vue&type=template&id=45eb3772&scoped=true&"
import script from "./SchoolRank.vue?vue&type=script&lang=js&"
export * from "./SchoolRank.vue?vue&type=script&lang=js&"
import style0 from "./SchoolRank.vue?vue&type=style&index=0&id=45eb3772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb3772",
  null
  
)

export default component.exports